<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="agentName" :showBackButton="true"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-alert
        prominent
        type="info"
        class="mb-4"
      >
        Här anger du de uppgifter vi använder för att matcha dig mot jobb. Uppgifterna blir synliga för åkeriet först när du  signerar något av deras jobb.
      </v-alert>
      <v-form ref="formEdit" v-on:submit.prevent>
        <!--matching-form-fields-->
        <app-matching-form-fields :data="viewData.matchingData" :newFileRows="viewData.newFileRows"></app-matching-form-fields>
      </v-form>
      <!--app-form-bottom-->
      <app-form-bottom
        :postWasInvalid="postWasInvalid"
        :errorOutput="errorOutput"
        @onSubmit="doSubmit"
        @onErrorOk="postWasInvalid = false"
        :loader="loader"
        :progress="true"
        :progressPercent="progressPercent"
      ></app-form-bottom>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import MatchingFormFields from '../components/MatchingFormFields'
import FormBottom from '../components/FormBottom'
import ViewToolbar from '../components/ViewToolbar'
import SnackBar from '../components/SnackBar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'

import { mapGetters } from 'vuex'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-matching-form-fields': MatchingFormFields,
    'app-form-bottom': FormBottom,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin, googleMapMixin],
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'agentData', 'agentName', 'access_token', 'isGreen']),
    headline() {
      return this.isGreen ? 'Skapa yrkesprofil' : 'Redigera yrkesprofil'
    }
  },
  data() {
    return {
      viewData: {
        matchingData: {
          qlfId_ar: [],
          homePos: '',
          qualificationAreaData_ar: []
        },
        newFileRows: {}
      },
      postWasInvalid: false,
      viewDataIsLoaded: false,
      errorOutput: '',
      progressPercent: 0,
      loader: false
    }
  },
  methods: {
    doSubmit() {
      const formIsValid = this.$refs.formEdit.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      if (this.viewData.matchingData.matchByMileRadius && !this.isValidCoordinate(this.viewData.matchingData.mapData.homePos)) {
        snackBarBus.$emit('message', 'Du måste ange utgångsposition')
        return
      }
      //show loader
      this.loader = true
      //compose postData
      let postData = {
        id: this.id,
        matchingData: this.viewData.matchingData,
        fileMetaData_ar: []//is appended per file
      }
      //compose formData
      let formData = new FormData()
      //append files and postData.fileMetaData_ar
      for (let qarId in this.viewData.newFileRows) {
        for (let newFileRow of this.viewData.newFileRows[qarId]) {
          console.log('newFileRow', newFileRow)
          if (newFileRow.file === undefined) {
            //skip this row
            continue
          }
          //append file to files
          formData.append('files', newFileRow.file)
          //append postData.fileMetaData_ar
          postData.fileMetaData_ar.push({
            mode: 'qdf'
            ,id: qarId
            ,name: newFileRow.file.name
            ,title: newFileRow.title
          })
        }
      }
      //append postData as JSON to formData
      formData.append('postData', JSON.stringify(postData))
//      console.log('formData', ...formData)
      //set config for axios request
      let config = {
        headers: {
          'Authorization': this.access_token,
        },
        onUploadProgress: function(progressEvent) {
          this.progressPercent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }.bind(this)
      }
      let url = this.url_composeApiUrl('/driver/matching-save')
//      console.log('post url: ' + url, ...formData)
      axios.post(url, formData, config)
        .then(response => {
//          console.log('post response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //refresh loggedInData via onAuth - due to we want fresh flag for isCompletedMatching
            let dataToDispatch = {
              loggedInData: response.data.returnData.loggedInData
            }
            this.$store.dispatch('onAuth', dataToDispatch).then(() => {
              //go to my-profile
              this.$router.replace({ name: 'my-profile'})
            })
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
            this.postWasInvalid = true
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
          this.postWasInvalid = true
        })
    },
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    let url = this.url_composeApiUrl('/driver/matching/' + this.id)
//    console.log('get', url)
    axios.get(url, config)
      .then(response => {
//        console.log('get response', response)
        if (response.data.success) {
          //success
          this.viewData = response.data.returnData.viewData
          this.viewDataIsLoaded = true
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>

</style>